import { assign } from 'xstate';
import { Context } from '../filtersMachine';

const updateContext = assign<Context, any>((ctx, evt) => ({
    ...evt.data,
}));

export default updateContext;
